.location-page.lager-page
  include ../location-base/location-page-header.pug
  +location-page-header("Lager")
